import { FormControl } from '@angular/forms';
import {
  CorporateDesignId,
  ICorporatePaletteColor,
  IFont,
  INormalText,
} from '@web/dtos';

export interface ICorporateDesignForm {
  id: FormControl<CorporateDesignId | null>;
  primaryColor: FormControl<string>;
  primaryFontColor: FormControl<string>;
  primaryBorderColor: FormControl<string>;
  primaryAlternativeColor: FormControl<string>;
  primaryDarkColor: FormControl<string>;
  primaryDarkFontColor: FormControl<string>;
  primaryDarkBorderColor: FormControl<string>;
  primaryDarkAlternativeColor: FormControl<string>;
  secondaryColor: FormControl<string>;
  secondaryFontColor: FormControl<string>;
  secondaryBorderColor: FormControl<string>;
  secondaryAlternativeColor: FormControl<string>;
  secondaryDarkColor: FormControl<string>;
  secondaryDarkFontColor: FormControl<string>;
  secondaryDarkBorderColor: FormControl<string>;
  secondaryDarkAlternativeColor: FormControl<string>;
  linkIcon: FormControl<string>;
  linkIconDark: FormControl<string>;
  fontSizeTitle: FormControl<number>;
  fontSizeText: FormControl<number>;
  fontSizeSmall: FormControl<number>;
  font: FormControl<IFont | null>;
  tabs: FormControl<INormalText[]>;
  buttonBorderRounding: FormControl<number>;
  colorPalette: FormControl<ICorporatePaletteColor[]>;
  primaryColorName: FormControl<string>;
  faviconFilename: FormControl<string>;
  faviconFileExtension: FormControl<string>;
}

export const CUSTOM = 'Benutzerdefiniert';
export const BY_PRIMARY_COLOR = 'Nach Primärfarbe';
export const BLACK = 'Schwarz';
export const WHITE = 'Weiß';
export const STANDARD = 'Standard';
export const NONE = 'Keine';
